import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable({
    providedIn: 'root'
})
export class AddToCalendarService {
    private SEPARATOR: string
    private calendarEvents: any[]
    private calendarStart: string
    private calendarEnd: string

    constructor() {
        this.SEPARATOR = (navigator.appVersion.indexOf('Win') !== -1) ? '\r\n' : '\n'
        this.calendarEvents = []
        this.calendarStart = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0'
        ].join(this.SEPARATOR);
        this.calendarEnd = this.SEPARATOR + 'END:VCALENDAR';
    }

    /**
     * Returns events array
     * @return {array} Events
     */
    events() {
        return this.calendarEvents
    }

    /**
     * Returns calendar
     * @return {string} Calendar in iCalendar format
     */
     calendar() {
        return this.calendarStart + this.SEPARATOR + this.calendarEvents.join(this.SEPARATOR) + this.calendarEnd;
    }

    /**
     * Add event to the calendar
     * @param  {string} subject     Subject/Title of event
     * @param  {string} description Description of event
     * @param  {string} location    Location of event
     * @param  {string} begin       Beginning date of event
     * @param  {string} stop        Ending date of event
     */
     addEvent(subject:string, description:string, location:string, begin:string, stop:string, url: string):string {
        // I'm not in the mood to make these optional... So they are all required
        if (typeof subject === 'undefined' ||
            typeof description === 'undefined' ||
            typeof location === 'undefined' ||
            typeof begin === 'undefined' ||
            typeof stop === 'undefined'
        ) {
            return '';  // error
        }

        if(url == undefined) {
            url = ''
        }
        else {
            url = url.split('?')[0]
        }

        //TODO add time and time zone? use moment to format?
        var start_date = new Date(begin);
        var end_date = new Date(stop);

        

        var start_year = ("0000" + (start_date.getFullYear().toString())).slice(-4);
        var start_month = ("00" + ((start_date.getMonth() + 1).toString())).slice(-2);
        var start_day = ("00" + ((start_date.getDate()).toString())).slice(-2);
        var start_hours = ("00" + (start_date.getHours().toString())).slice(-2);
        var start_minutes = ("00" + (start_date.getMinutes().toString())).slice(-2);
        var start_seconds = ("00" + (start_date.getMinutes().toString())).slice(-2);

        var end_year = ("0000" + (end_date.getFullYear().toString())).slice(-4);
        var end_month = ("00" + ((end_date.getMonth() + 1).toString())).slice(-2);
        var end_day = ("00" + ((end_date.getDate()).toString())).slice(-2);
        var end_hours = ("00" + (end_date.getHours().toString())).slice(-2);
        var end_minutes = ("00" + (end_date.getMinutes().toString())).slice(-2);
        var end_seconds = ("00" + (end_date.getMinutes().toString())).slice(-2);

        // Since some calendars don't add 0 second events, we need to remove time if there is none...
        var start_time = '';
        var end_time = '';
        if (Number(start_hours) + Number(start_minutes) + Number(start_seconds) + Number(end_hours) + Number(end_minutes) + Number(end_seconds) !== 0) {
            start_time = 'T' + start_hours + start_minutes + start_seconds;
            end_time = 'T' + end_hours + end_minutes + end_seconds;
        }

        var start = start_year + start_month + start_day + start_time;
        var end = end_year + end_month + end_day + end_time;

        var startGMT = moment(begin).utc().format('YYYYMMDDTHHmmss')
        var endGMT = moment(stop).utc().format('YYYYMMDDTHHmmss')

        var calendarEvent = [
            'BEGIN:VEVENT',
            'CLASS:PUBLIC',
            'DESCRIPTION:' + description,
            'DTSTART:' + startGMT + 'Z',
            'DTEND:' + endGMT + 'Z',
            'LOCATION:' + location,
            'URL:' + url,
            'SUMMARY;LANGUAGE=en-us:' + subject,
            'TRANSP:TRANSPARENT',
            'END:VEVENT'
        ].join(this.SEPARATOR);

        this.calendarEvents.push(calendarEvent);
        return calendarEvent;
    }

    /**
         * Download calendar using the saveAs function from filesave.js
         * @param  {string} filename Filename
         * @param  {string} ext      Extention
         */
     download(filename:string, ext:string) {
        if (this.calendarEvents.length < 1) {
            return
        }

        ext = (typeof ext !== 'undefined') ? ext : '.ics';
        filename = (typeof filename !== 'undefined') ? filename : 'calendar';
        var calendar = this.calendarStart + this.SEPARATOR + this.calendarEvents.join(this.SEPARATOR) + this.calendarEnd;
        window.open( "data:text/calendar;charset=utf8," + escape(calendar).replace('%u2019', "'").replace('%u2019', "'").replace('%u2019', "'").replace('%u2019', "'").replace('%u2019', "'").replace('%u2019', "'"));
    }

    reset() {
        this.calendarEvents = []
    }

    
    /**
     * Add event to the calendar
     * @param  {string} subject     Subject/Title of event
     * @param  {string} description Description of event
     * @param  {string} location    Location of event
     * @param  {string} begin       Beginning date of event. Example: 20230127
     * @param  {string} stop        Ending date of event. Example: 20230127 
     */
    googleCalendarLink(subject:string, description:string, location:string, begin:string, stop:string ): string {
        
        let link = `https://www.google.com/calendar/render?action=TEMPLATE&text=${subject}&location=${location}&dates=${begin}/${stop}&details=${description}&sprop=&sprop=name:`
        return link
    }
}
